import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import StepsWizard from "../../../components/templates/StepsWizard";
import ClientCreationType from "./ClientCreationType";
import TemplateSelection from "./TemplateSelection";
import ClientDetails from "./ClientDetails";
import ClientAddress from "./ClientAddress";
import ClientAccountingNumber from "./ClientAccountingNumber";
import { createRecord } from "../../clientDetails/clientDetailsSlice";
import { reload } from "../ClientsSlice";
var unflatten = require("flat").unflatten;

const NewClientWizard = (props) => {
  const { hideWizard } = props;
  let history = useHistory();
  const dispatch = useDispatch();
  const [isBtl, setIsBtl] = useState(null);
  const [nextDisabled, setNextDisabled] = useState(true);
  const [values, setValues] = useState({});
  const activeTemplate = useSelector(
    (state) => state.clientDetails.activeTemplate
  );

  const createLoading = useSelector(
    (state) => state.pendingActions["clientDetails/create"]
  );

  const changeIsBtl = (val) => {
    setIsBtl(val);
  };

  const slide2Required =
    values.creation_type === "list"
      ? ["template"]
      : values.creation_type === "fromScratch" && isBtl !== true
      ? ["name", "category_id"]
      : [
          "specific_data.comittee_name",
          "specific_data.organization_branch_number",
          "specific_data.comittee_number",
          "specific_data.organization_branch_name",
        ];
  let slide2Validation =
    values.creation_type === "fromScratch"
      ? [...slide2Required, "phone_number", "fax_number", "email"]
      : slide2Required;
  const steps = [
    {
      title: null,
      description: null,
      headline: <FormattedMessage id="app.clients.creationHeadline" />,
      subtitle: <FormattedMessage id="app.clients.creationSubtitle" />,
      required: ["creation_type"],
      validation: ["creation_type"],
      comp: <ClientCreationType />,
    },
    {
      title: null,
      description: null,
      headline: null,
      required: slide2Required,
      validation: slide2Validation,
      subtitle:
        values.creation_type === "list" ? (
          <FormattedMessage id="app.clients.fromListSubtitle" />
        ) : (
          <FormattedMessage id="app.clients.fromScratchSubtitle" />
        ),
      comp:
        values.creation_type === "list" ? (
          <TemplateSelection />
        ) : (
          <ClientDetails values={values} changeIsBtl={changeIsBtl} />
        ),
    },
    {
      title: null,
      description: null,
      required: ["accounting_code"],
      validation: ["accounting_code"],
      subtitle:
        values.creation_type === "list" ? (
          <FormattedMessage id="app.clients.accountingSubtitle" />
        ) : (
          <FormattedMessage id="app.clients.addressSubtitle" />
        ),
      comp:
        values.creation_type === "list" ? (
          <ClientAccountingNumber values={values} />
        ) : (
          <ClientAddress />
        ),
    },
  ];

  const hide = () => {
    setNextDisabled(true);
    setValues({});
    hideWizard();
  };

  const setNext = (val) => {
    setNextDisabled(val);
  };

  const onFinish = async (formValues) => {
    const deepValues = unflatten(formValues);
    let finalClient = null;
    if (values.creation_type === "list") {
      const serviceTypes = activeTemplate.service_types.map((s) => s.id);
      finalClient = {
        ...deepValues,
        ...activeTemplate,
        service_types_ids: serviceTypes,
      };
    } else {
      finalClient = deepValues;
    }
    const action = await dispatch(createRecord(finalClient));
    if (!action.error) {
      hide();
      dispatch(reload());

      const url = "/admin/clients/" + action.payload.data.id;
      history.push(url);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    //pop error notification
  };

  const changeValues = (val) => {
    setValues(val);
  };

  const onValuesChange = (changedValues, allValues) => {
    const newValues = unflatten(allValues);
    setValues({ ...values, ...newValues });
  };

  const formLayout = {
    labelCol: { span: 9 },
    wrapperCol: { span: 15 },
  };

  return (
    <StepsWizard
      formLayout={formLayout}
      steps={steps}
      setNext={setNext}
      changeValues={changeValues}
      values={values}
      onCancel={hide}
      onValuesChange={onValuesChange}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={hide}
      saveLoading={createLoading}
      createText={<FormattedMessage id="app.clients.createNewClient" />}
      nextDisabled={nextDisabled}
    />
  );
};

export default NewClientWizard;
